<template>
	<v-sheet color="transparent"  height="100%">
		<v-component v-for="( component, id ) in components" :key="id" :is="component"></v-component>
	</v-sheet>
</template>

<script>
	import Vuex from "vuex";
	import AddUser from "@/components/admin/elements/AddUser" 
	import Welcome from "@/components/content/Welcome" 
	import AddOrganisation from "@/components/admin/elements/AddOrganisation"

	export default { 
		name: "AdminDashboard", 
		data: () =>{
			return {
				components: {
					"Welcome": Welcome,
					"Add_User": AddUser,
					"Add_Organisation": AddOrganisation,
				}
			}
		},
		components: {
			AddUser
		},
		computed: {
			...Vuex.mapState({
				user: state => state.user
			}),
			dashboardSettings(){
				return this.user.dashboard_settings
			},	
			sortedComponents(){
				return this.components;
			}
		},
		created(){
		}

	}	
</script>